import React from "react";
import "./BenefitsCards.css";

const BenefitsCard = ({ heading, body }) => {
    return (
        <div className="m-0 py-2 column is-half-tablet is-one-quarter-desktop">
            <div className="m-0 benefits-card">
                <h4 className="mb-3 p-0 benefitCard is-align-center">{heading}</h4>
                <p className="m-0 p-0 is-align-center">{body}</p>
            </div>
        </div>
    );
};

const BenefitsCards = ({ benefits }) => {
    return (
        <div className="mt-5 p-0 benefits-cards-container">
            <div className="columns is-centered">
                {benefits.map((benefit, index) => (
                    <BenefitsCard 
                        key={index}
                        heading={benefit.heading}
                        body={benefit.body}
                    />
                ))}
            </div>
        </div>
    );
};

export default BenefitsCards;